import { z } from 'zod'

import { MediaKindSchema } from '@/prisma/generated/zod'

export const mediaIdSchema = z
  .string({
    required_error: 'errors.missing_id',
    invalid_type_error: 'errors.invalid_id',
  })
  .length(14, { message: 'errors.invalid_id' })
  .startsWith('med_', { message: 'errors.invalid_id' })

export const archiveMediaSchema = z.object({
  _intent: z.literal('archiveMedia'),
})

export const restoreMediaSchema = z.object({
  _intent: z.literal('restoreMedia'),
})

export const deleteMediaSchema = z.object({
  _intent: z.literal('deleteMedia'),
})

// ImageKit extra fields schema
export const imageKitExtraFieldsSchema = z.object({
  fileId: z.string(),
  name: z.string(),
  size: z.number(),
  versionInfo: z.object({
    id: z.string(),
    name: z.string(),
  }),
  filePath: z.string(),
  fileType: z.string(),
  height: z.number().optional(),
  width: z.number().optional(),
  orientation: z.number().optional(), // Only for images
  bitRate: z.number().optional(), // Only for videos
  duration: z.number().optional(), // Only for videos
  videoCodec: z.string().optional(), // Only for videos
  thumbnailUrl: z.string().optional(), // Generated thumbnail URL
  AITags: z.array(z.string()).nullable().optional(),
  description: z.string().nullable().optional(),
})

export const createMediaSchema = z.object({
  src: z.string(),
  kind: z
    .literal('')
    .transform(() => 'image' as const)
    .or(MediaKindSchema.default('image')),
  extraFields: imageKitExtraFieldsSchema.optional(),
})

export type CreateMediaSchema = z.infer<typeof createMediaSchema>

export const mediaStatusSchema = z.enum(['live', 'archived'])

export type MediaStatus = z.infer<typeof mediaStatusSchema>

export const listMediasOptionsSchema = z.object({
  page: z.coerce.number().min(1).default(1),
  limit: z.number().min(1).max(100).default(30),
  status: mediaStatusSchema.default('live'),
  sortBy: z.enum(['date']).default('date'),
  sortDir: z.enum(['asc', 'desc']).default('desc'),
})

export type ListMediasOptions = z.infer<typeof listMediasOptionsSchema>

export const validateMediaTypeSchema = z.enum([
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'video/mp4',
])

export type MediaTypeValidation = z.infer<typeof validateMediaTypeSchema>
